import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TuiTextfieldControllerModule, TuiTextareaModule, TuiInputModule } from '@taiga-ui/legacy';
import { TuiAvatar, TuiBlock, TuiCheckbox } from '@taiga-ui/kit';
import {
  TuiDataList,
  TuiLoader,
  TuiScrollbar,
  TuiScrollable,
  TuiDropdown,
  TuiButton,
  TuiHint,
  TuiFallbackSrcPipe,
  TuiInitialsPipe,
  TuiAutoColorPipe,
} from '@taiga-ui/core';
import { TuiMedia, TuiActiveZone } from '@taiga-ui/cdk';
import { WaIntersectionObserver } from '@ng-web-apis/intersection-observer';
import { SharedModule } from '@src/app/shared';
import { IconModule } from '@src/app/modules/icon';

import { MessageModule } from '../message';

import { MessageListComponent } from './message-list.component';

@NgModule({
  declarations: [MessageListComponent],
  imports: [
    CommonModule,
    FormsModule,
    IconModule,
    ...WaIntersectionObserver,
    MessageModule,
    SharedModule,
    TuiActiveZone,
    TuiAvatar,
    TuiBlock,
    TuiCheckbox,
    ...TuiDropdown,
    TuiInputModule,
    TuiTextareaModule,
    TuiButton,
    ...TuiDataList,
    TuiLoader,
    TuiMedia,
    TuiScrollbar,
    TuiScrollable,
    TuiTextfieldControllerModule,
    ...TuiHint,
    TuiFallbackSrcPipe,
    TuiInitialsPipe,
    TuiAutoColorPipe,
  ],
  exports: [MessageListComponent],
})
export class MessageListModule {}
